import styled from "styled-components";

import { ServiceCard } from "../../../../components/Cards";

export const Container = styled.div`
  padding-top: ${({theme}) => theme.spacings.spacing_xl};
`;

export const CustomCard = styled(ServiceCard)`
  min-height: 0;

  @media only screen and (max-width: 560px) {
    margin-bottom: 26px;
  }
`;
